module.exports = __webpack_public_path__ + "img/icon-food.d75a4b70.png";